import { useEffect } from "react";
import useTranslator from "../../hooks/useTranslator";
import styles from "./authenticateYourId/authenticateYourId.module.css";

const KycVerificationPopup = ({
  loadUser,
  showPopup,
  setKycVerificationPopup,
  isGuarantor,
}) => {
  const { _t } = useTranslator();

  useEffect(() => {
    if (showPopup) {
      setTimeout(async () => {
        await loadUser();
        setKycVerificationPopup(false);
      }, 5000);
    }
  }, []);

  return (
    <>
      {showPopup && (
        <div
          className={`${styles.overlay} popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${isGuarantor ? "guarantorBg" : ""}`}
          style={{ zIndex: 100 }}
        >
          <div
            className={`popup-content2 popup-content bg-white kycDonePopup ${styles.authModalSurface}`}
          >
            <div className="row relativeposition custom-mb-5">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
                <div className="authenticateid-header text-center">
                  <h4>{_t("kycVerificationDone")}</h4>
                  <p>{_t("yourKycVerificationHasBeenCompleted")}</p>
                </div>
              </div>
            </div>
            <div className="text-center kyc-success-container-wrapper">
              <div className="kyc-success-container">
                <div className="kyc-success-perspective">
                  <div className="kyc-success-animation-box">
                    <div className="kyc-success-card">
                      <div className="kyc-success-card-shimmer"></div>
                      <div className="kyc-success-card-left">
                        <div className="kyc-success-card-avatar">
                          <svg
                            className="kyc-success-card-avatar-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        </div>
                        <div className="kyc-success-card-line"></div>
                      </div>
                      <div className="kyc-success-card-right">
                        <div className="kyc-success-card-lines">
                          <div className="kyc-success-card-line-long"></div>
                          <div className="kyc-success-card-line-medium"></div>
                        </div>
                        <div className="kyc-success-card-lines-small">
                          <div className="kyc-success-card-line-small"></div>
                          <div className="kyc-success-card-line-xsmall"></div>
                          <div className="kyc-success-card-line-small-medium"></div>
                        </div>
                      </div>
                    </div>
                    <div className="kyc-success-tick-container">
                      <div className="kyc-success-tick-circle">
                        <svg
                          className="kyc-success-tick-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={3}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className={styles.kycProcessingMessage}>
              {_t(
                "kycDocumentsAreReceivedAndKycProcessingIsStarted",
                "Your KYC documents have been received and KYC processing has started."
              )}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default KycVerificationPopup;
